// 對應 CRM.Domain.EnumType.TransferOrderStatus 列舉
export class TransferOrderStatus {
  static get None () {
    return 0
  }
  static get StockPending () {
    return 1
  }
  static get SalePending () {
    return 2
  }
  static get Invalid () {
    return 3
  }
  static get Approved () {
    return 4
  }

  static TransferOrderStatusName (status) {
    let tmpStatus = parseInt(status)
    let type = isNaN(tmpStatus) ? -1 : tmpStatus
    let name = ''
    switch (type) {
      case 0:
        name = ''
        break
      case 1:
        name = '倉管待處理'
        break
      case 2:
        name = '業務待處理'
        break
      case 3:
        name = '作廢重開報價單'
        break
      case 4:
        name = '轉拋ERP、並寫回報價單'
        break
    }
    return name
  }
}
